module.exports = __webpack_public_path__ + "img/GraceNew.11978d59.png";